import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionService } from 'src/app/services/permission.service';
import { portalCommands } from 'src/app/utils/portal-path';
import * as QRCode from 'qrcode';
import { BusesService } from 'src/app/services/buses.service';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-bus-detail',
  templateUrl: './bus-detail.component.html',
  styleUrls: ['./bus-detail.component.css']
})
export class BusDetailComponent {
  bus: any = null;
  loading = true;
  errorMessage = '';
  qrDataUrl = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private busesService: BusesService,
    private languageService: LanguageService,
    public permissions: PermissionService,
  ) {}

  async ngOnInit() {
    this.route.paramMap.subscribe(async params => {
      const id = params.get('id');
      if (!id) {
        this.router.navigate(portalCommands(this.router, 'settings', 'buses'));
        return;
      }
      await this.loadBus(id);
    });
  }

  async loadBus(id: string) {
    this.loading = true;
    this.errorMessage = '';
    this.qrDataUrl = '';
    try {
      this.bus = await this.busesService.getById(id);
      if (!this.bus) {
        this.errorMessage = 'BUSES.NOT_FOUND';
      } else {
        await this.refreshQrCode();
      }
    } catch {
      this.errorMessage = 'BUSES.LOAD_FAILED';
      this.bus = null;
    } finally {
      this.loading = false;
    }
  }

  private async refreshQrCode() {
    const code = String(this.bus?.qrCode || '').trim();
    if (!code) {
      this.qrDataUrl = '';
      return;
    }
    try {
      this.qrDataUrl = await QRCode.toDataURL(code, {
        width: 168,
        margin: 1,
        errorCorrectionLevel: 'M',
        color: { dark: '#173654', light: '#ffffff' },
      });
    } catch {
      this.qrDataUrl = '';
    }
  }

  get busesLink(): string[] {
    return portalCommands(this.router, 'settings', 'buses');
  }

  goBack() {
    this.router.navigate(portalCommands(this.router, 'settings', 'buses'));
  }

  get students(): any[] {
    return this.bus?.students || [];
  }

  studentName(item: any): string {
    const isAr = this.languageService.current === 'ar';
    const name = isAr
      ? `${item.firstNameAr || ''} ${item.lastNameAr || ''}`.trim()
      : `${item.firstNameEn || ''} ${item.lastNameEn || ''}`.trim();
    return name || '—';
  }

  openStudent(item: any) {
    if (!item?.id || !this.permissions.canView('students')) {
      return;
    }
    this.router.navigate(portalCommands(this.router, 'settings', 'students', item.id));
  }

  valueOrDash(value: unknown): string {
    if (value == null) {
      return '—';
    }
    const text = String(value).trim();
    return text || '—';
  }
}
